
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { Model, ModelProperty } from 'models/Model';


export class OrderOnboardingViewModel extends Model<OrderOnboardingViewModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'taskflowId', type: 'guid', languageString: 'orderOnboardingView.property.taskflowId' },
		{ name: 'responsibleUserId', type: 'guid', languageString: 'orderOnboardingView.property.responsibleUserId' },
		{ name: 'companyId', type: 'guid', languageString: 'orderOnboardingView.property.companyId' },
		{ name: 'companyName', type: 'string', languageString: 'orderOnboardingView.property.companyName' },
		{ name: 'orders', type: 'OrderDataModel[]', languageString: 'orderOnboardingView.property.orders', isHidden: true, isArray: true, isObject: true, new: () => { return new OrderDataModel }, properties: () => { return OrderDataModel.classProperties } },
		{ name: 'activeQualificationCall', type: 'boolean', languageString: 'orderOnboardingView.property.activeQualificationCall' }
	];
	[key: string]: any;
	
	public taskflowId?: string;
	public responsibleUserId?: string;
	public companyId?: string;
	public companyName: string;
	public orders: OrderDataModel[];
	public activeQualificationCall: boolean;
    
	constructor(){
		super();
		this.taskflowId = undefined;
		this.responsibleUserId = undefined;
		this.companyId = undefined;
		this.companyName = '';
		this.orders = [];
		this.activeQualificationCall = false;
		
	}
	getProperties(){
		return OrderOnboardingViewModel.classProperties;
	}
}
export class OrderDataModel extends Model<OrderDataModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'orderId', type: 'guid', languageString: 'orderData.property.orderId' },
		{ name: 'approvedDate', type: 'Date', languageString: 'orderData.property.approvedDate' },
		{ name: 'products', type: 'ProductDataModel[]', languageString: 'orderData.property.products', isHidden: true, isArray: true, isObject: true, new: () => { return new ProductDataModel }, properties: () => { return ProductDataModel.classProperties } }
	];
	[key: string]: any;
	
	public orderId?: string;
	public approvedDate?: Date;
	public products: ProductDataModel[];
    
	constructor(){
		super();
		this.orderId = undefined;
		this.approvedDate = undefined;
		this.products = [];
		
	}
	getProperties(){
		return OrderDataModel.classProperties;
	}
}
export class ProductDataModel extends Model<ProductDataModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'orderLineId', type: 'guid', languageString: 'productData.property.orderLineId' },
		{ name: 'name', type: 'string', languageString: 'productData.property.name' },
		{ name: 'productValue', type: 'number', languageString: 'productData.property.productValue' },
		{ name: 'invoiced', type: 'Date', languageString: 'productData.property.invoiced' },
		{ name: 'containOpenOnboardingTaskflows', type: 'boolean', languageString: 'productData.property.containOpenOnboardingTaskflows' }
	];
	[key: string]: any;
	
	public orderLineId?: string;
	public name: string;
	public productValue: number;
	public invoiced?: Date;
	public containOpenOnboardingTaskflows: boolean;
    
	constructor(){
		super();
		this.orderLineId = undefined;
		this.name = '';
		this.productValue = 0;
		this.invoiced = undefined;
		this.containOpenOnboardingTaskflows = false;
		
	}
	getProperties(){
		return ProductDataModel.classProperties;
	}
}

